import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { MemberQuery } from '../../account/member/member.query';
import { AccountStatus } from '../../account/member/models/account-status.model';
import { LoggingService } from '../../shared/services/core/logging.service';

export function firstTimeUserGuard(redirectPath: string = 'register/firsttime'): CanActivateFn {
  return (route, state) => {
    const authService = inject(AuthService);
    const memberQuery = inject(MemberQuery);
    const router = inject(Router);
    const logService = inject(LoggingService);

    if (authService.isAuthenticated() && memberQuery.getUserContext().status === AccountStatus.FirstTimeUser) {
      logService.info('Redirecting to first time user registration...', { path: redirectPath });
      return router.createUrlTree(['/' + redirectPath]);
    }

    return true;
  };
}
